<div class="p-3 text-sm text-slate-900">
  @switch (state().kind) {
    @case ('no-document') {
      <div class="text-slate-500 italic">No PDF loaded.</div>
    }
    @case ('no-claims') {
      <div class="text-slate-500 italic">No claims available for this PDF.</div>
    }
    @case ('ready') {
      @let s = state();
      @if (s.kind === 'ready') {
        <div class="text-xs uppercase tracking-wider text-slate-500 mb-2">
          Claims ({{ s.rows.length }})
        </div>
        @for (r of s.rows; track r.id) {
          <div
            [attr.data-claim-card]="r.id"
            class="rounded p-2 mb-2 cursor-pointer border transition bg-white hover:bg-slate-50"
            [class.bg-slate-100]="r.active"
            [style.border-color]="r.count > 0 ? r.color : 'rgba(148,163,184,0.4)'"
            [style.border-style]="r.count > 0 ? 'solid' : 'dashed'"
            (click)="onCardClick(r.id)"
          >
            <div class="flex items-center gap-2">
              <span
                class="inline-block w-2.5 h-2.5 rounded-full"
                [style.background]="r.color"
              ></span>
              <span class="ml-auto text-xs text-slate-500">
                {{ r.count > 0 ? r.count + ' box' + (r.count === 1 ? '' : 'es') : 'unbacked' }}
              </span>
            </div>
            <div class="mt-1 text-slate-800">{{ r.text }}</div>
          </div>
        }
      }
    }
  }
</div>
